type WorkloadAdjustment = {
  from: string;
  to: string;
  project: { load: number };
  consolidated: { load: number; capacity: number };
};

const workloadAdjustment: WorkloadAdjustment = {
  from: "",
  to: "",
  project: { load: 0 },
  consolidated: { load: 0, capacity: 0 },
};

export type { WorkloadAdjustment };

export { workloadAdjustment };
